import { connect } from 'react-redux';

import ConfirmationSuccess from './ConfirmationSuccess';
import { RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  status: state.investments.status,
});

export default connect(mapStateToProps)(ConfirmationSuccess);

